import type ThemePalette from '@ui/theme/ThemePalette'
import sharedPalette from '@ui/theme/themes/shared/palette'

const palette: ThemePalette = {
  ...sharedPalette,
  primary: {
    default: '135, 79, 255',
    strong: '162, 122, 255',
    extraStrong: '205, 184, 255',
    subtle: '161, 120, 255, 0.15',
    activity: '38, 34, 59',
    workflowLine: '103, 74, 172',
    workflowLabelOutline: '63, 47, 107',
    workflowLabelBg: '45, 37, 66',
    alt: '163, 110, 255',
    3: '197, 164, 255',
  },
  gray: {
    1: '238, 238, 240',
    2: '180, 180, 204',
    3: '134, 134, 163',
    4: '80, 80, 98',
    5: '36, 36, 52',
    6: '29, 29, 42',
    overlay: '75, 75, 104',
  },
  background: {
    default: '26, 25, 38',
    modal: '33, 33, 48',
    workflowBg: '26, 25, 38',
    workflowPanel: '29, 29, 42',
  },
  overlay: {
    default: '75, 75, 104, 0.23',
    strong: '75, 75, 104, 0.5',
    subtle: '75, 75, 104, 0.08',
    selected: '161, 120, 255, 0.08',
    thread: '252, 178, 0, 0.06',
    fullscreen: '0, 0, 0, 0.40',
  },
  secondary: {
    green: {
      default: '0, 185, 77',
      strong: '85, 231, 135',
      extraStrong: '168, 255, 198',
      subtle: '86, 245, 169, 0.13',
      2: '0, 148, 62',
    },
    blue: {
      default: '0, 169, 254',
      strong: '49, 174, 255',
      extraStrong: '163, 219, 255',
      subtle: '53, 169, 243, 0.13',
    },
    yellow: {
      default: '255, 198, 72',
      strong: '255, 237, 186',
      extraStrong: '250, 242, 220',
      subtle: '190, 164, 87, 0.13',
    },
    orange: {
      default: '255, 173, 42',
      strong: '255, 183, 69',
      extraStrong: '255, 222, 171, 1',
      subtle: '255, 196, 101, 0.13',
    },
    red: {
      default: '240, 58, 20',
      strong: '255, 115, 88',
      extraStrong: '255, 187, 173',
      subtle: '255, 136, 113, 0.13',
      2: '255, 96, 66',
    },
  },
  mention: {
    their: {
      name: '11, 159, 255',
      bg: '11, 159, 255, 0.14',
    },
    your: {
      name: '255, 205, 79',
      bg: '255, 180, 72, 0.15',
    },
    chat: {
      bubble: '255, 255, 255, 0.16',
    },
  },
  note: {
    text: '255, 248, 228',
    label: '194, 159, 81',
    highlight: '252, 178, 0',
    bg: '45, 41, 42',
    line: '48, 47, 62',
  },
  ai: {
    default: '192, 97, 255',
    strong: '203, 125, 255',
    extraStrong: '221, 171, 255',
    superStrong: '242, 222, 255',
    subtle: '192, 97, 255, 0.16',
    gradient: {
      default:
        'linear-gradient(89.4deg, rgb(45, 33, 54) 10%, rgb(44, 29, 51) 55%, rgb(42, 31, 43) 100%)',
    },
  },
  contact: {
    leaf: {
      default: '0, 205, 107',
      strong: '111, 255, 186',
      subtle: '88, 255, 175, 0.11',
    },
    watermelon: {
      default: '253, 75, 87',
      strong: '255, 130, 138',
      subtle: '255, 161, 168, 0.09',
    },
    sky: {
      default: '0, 159, 254',
      strong: '136, 210, 255',
      subtle: '105, 199, 255, 0.09',
    },
    tangerine: {
      default: '255, 157, 0',
      strong: '255, 204, 121',
      subtle: '255, 206, 126, 0.10',
    },
    cherokee: {
      default: '220, 194, 104',
      strong: '255, 236, 154',
      subtle: '255, 226, 120, 0.14',
    },
    turquoise: {
      default: '0, 211, 195',
      strong: '119, 255, 245',
      subtle: '119, 255, 245, 0.09',
    },
    mauve: {
      default: '197, 128, 207',
      strong: '244, 170, 255',
      subtle: '246, 184, 255, 0.10',
    },
    indigo: {
      default: '131, 87, 255',
      strong: '196, 141, 255',
      subtle: '189, 166, 255, 0.10',
    },
    salmon: {
      default: '255, 153, 144',
      strong: '255, 177, 170',
      subtle: '255, 193, 187, 0.14',
    },
    stone: {
      default: '156, 170, 191',
      strong: '209, 220, 237',
      subtle: '198, 213, 236, 0.15',
    },
  },
  gradient: {
    skeleton: {
      from: '75, 75, 104, 0.5',
      to: '75, 75, 104, 0.23',
    },
  },
  external: {
    google: '36, 129, 255',
    twitter: '34, 170, 253',
    facebook: '28, 127, 255',
    linkedin: '14, 115, 217',
  },
}

export default palette
